import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import QuadLayout from "@/pages/QuadLayout";
import LandmarkPage from "@/pages/LandmarkPage";
import UnderConstruction from "@/components/UnderConstruction";
import { LOCKED_AREAS } from "@/components/zone/navConfig";
import { AuthProvider } from "@/auth/AuthContext";
import AuthCallback from "@/auth/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth return synchronously (during render, NOT in useEffect) to
  // beat the AuthProvider's /me check and avoid a race condition.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Campus Quad: keeps WebGL canvas mounted across locked-area routes */}
      <Route path="/" element={<QuadLayout />}>
        <Route index element={null} />
        {Object.entries(LOCKED_AREAS).map(([id, label]) => (
          <Route
            key={id}
            path={id}
            element={<UnderConstruction area={label} />}
          />
        ))}
      </Route>

      {/* Landmark detail pages */}
      <Route path="/landmark/:id" element={<LandmarkPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
